import createIcon from '../../createIcon';

/**
 * @component @name AddTask
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNS4xOEw5LjU5IDE2LjZMNS4zNSAxMi4zNkw2Ljc2IDEwLjk1TDkuNTkgMTMuNzhMMTkuNTkgMy43OEwyMSA1LjE4Wk0xMSAyMEM2LjU5IDIwIDMgMTYuNDEgMyAxMkMzIDcuNTkgNi41OSA0IDExIDRDMTIuNTcgNCAxNC4wNCA0LjQ2IDE1LjI4IDUuMjVMMTYuNzMgMy44QzE1LjEgMi42NyAxMy4xMyAyIDExIDJDNS40OCAyIDEgNi40OCAxIDEyQzEgMTcuNTIgNS40OCAyMiAxMSAyMkMxMi43MyAyMiAxNC4zNiAyMS41NiAxNS43OCAyMC43OEwxNC4yOCAxOS4yOEMxMy4yOCAxOS43NCAxMi4xNyAyMCAxMSAyMFpNMTggMTVIMTVWMTdIMThWMjBIMjBWMTdIMjNWMTVIMjBWMTJIMThWMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddTask = createIcon('AddTask', [
  [
    'path',
    {
      d: 'M21 5.18L9.59 16.6L5.35 12.36L6.76 10.95L9.59 13.78L19.59 3.78L21 5.18ZM11 20C6.59 20 3 16.41 3 12C3 7.59 6.59 4 11 4C12.57 4 14.04 4.46 15.28 5.25L16.73 3.8C15.1 2.67 13.13 2 11 2C5.48 2 1 6.48 1 12C1 17.52 5.48 22 11 22C12.73 22 14.36 21.56 15.78 20.78L14.28 19.28C13.28 19.74 12.17 20 11 20ZM18 15H15V17H18V20H20V17H23V15H20V12H18V15Z',
      key: '19r9a0',
    },
  ],
]);

export default AddTask;
